module.exports = __webpack_public_path__ + "static/assets/7cf82cd9bd601cfee5e715c0eb5343ef.mp3";